<template>
  <div>
    <v-simple-table
      fixed-header
      height="300px"
      width="300px"
      class="px-4 ud-table"
      :class="receiptList.length ? 'h-100' : ''"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th>Code</th>
            <th>Date</th>
            <th class="text-right">Amount</th>
          </tr>
        </thead>
        <tbody v-if="receiptList.length">
          <tr v-for="(rc, udIndex) in receiptList" :key="rc.udIndex">
            <td>{{ rc.number }}</td>
            <td>{{ normaliseDate(rc.date) }}</td>
            <td class="text-right">{{ formatNumber(rc.receivedAmount) }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td>
              <div class="d-flex align-content-start flex-wrap pt-15">
                <v-img
                  src="../../../assets/recent_transactions.svg"
                  :aspect-ratio="3.9"
                  contain
                >
                  <!-- src="../../../assets/no_due.svg" -->
                </v-img>
                <div
                  class="text-center title-style pt-10 mx-auto"
                  style="padding-bottom: 150px !important"
                >
                  No Recent Transanctions !
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import { format, formatNumber } from "accounting";

export default {
  data: () => ({
    receiptList: [],
  }),
  mounted() {
    this.getRecentTrsc();
  },
  methods: {
    getRecentTrsc() {
      let url = `/api/wesupport/Receipt/getMemberReceiptList?memberId=${this.decryptMemId()}`;
      callApi(url, "get", "")
        .then((res) => {
          this.receiptList = res.data.data;
        })
        .catch((err) => {});
    },
  },
};
</script>
